import { render } from "./HomeVet.vue?vue&type=template&id=027525e6&scoped=true"
import script from "./HomeVet.vue?vue&type=script&lang=js"
export * from "./HomeVet.vue?vue&type=script&lang=js"

import "./HomeVet.vue?vue&type=style&index=0&id=027525e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027525e6"]])

export default __exports__